import { CamelCaseLocation } from '@eventbrite/global-nav';
import { PointOfInterestAppProps, ThingsToDoAppProps } from '../types';

export function getLocation({
    location_slug,
    place_id,
    query_location_data,
    shortPlaceName,
}: (ThingsToDoAppProps | PointOfInterestAppProps) & {
    location_slug?: string;
    place_id?: string;
}) {
    if (location_slug && place_id && query_location_data) {
        return {
            slug: location_slug || '',
            placeId: place_id,
            placeType: '',
            latitude: query_location_data.latitude || 0,
            longitude: query_location_data.longitude || 0,
            currentPlace: shortPlaceName || '',
            currentPlaceParent: '',
            isOnline: query_location_data.isOnline,
        } as CamelCaseLocation;
    }
}
